// src/api/adminSettingsApi.js
import api from "./axios";

/**
 * Admin Settings API
 * BaseURL gérée par axios.js -> "/api/v1"
 * Donc ici on utilise des routes relatives: "/admin/..."
 */
export const AdminSettingsAPI = {
  async getCreditsSettings() {
    const res = await api.get("/admin/settings/credits");
    return res.data;
  },

  async updateCreditsSettings(payload) {
    // payload: { credit_debit_mode: "reserved"|"consumed", allow_pack_stacking: boolean }
    //const res = await api.put("/admin/settings/credits", payload);
    const res = await api.put("/admin/settings/credits", payload);
    return res.data;
  },
};
